// Block Types - matching Flutter BlockTypes exactly (PascalCase)

export enum BlockTypes {

  BANNER = 'Banner',

  SEARCH_BAR = 'SearchBar',

  STICKERS = 'Stickers',

  ORGANIZATIONS = 'Organizations',

  RICH_TEXT = 'RichText',

  ANNOUNCEMENT = 'Announcement',

  QUESTION = 'Question',

  COLLECTIONS = 'Collections',

  LIST = 'List',
}

// Search Types (matching Flutter's StaticSearchType enum)

export enum SearchType {

  NON_PROFITS = 'non-profits',

  ORGANIZATIONS = 'organizations',

  USERS = 'users',

  STICKERS = 'stickers',
}

// Base Block Interface
export interface BaseBlock {
  id: string;
  sortOrder: number;
  blockType: BlockTypes;
}

// Banner Block
export interface BannerItem {
  imageUrl: string;
  deepLink: string;
}

export interface BannerBlock extends BaseBlock {
  blockType: BlockTypes.BANNER;
  title?: string;
  setFullWidth: boolean;
  items: BannerItem[];
}

// Search Bar Block
export interface SearchBarBlock extends BaseBlock {
  blockType: BlockTypes.SEARCH_BAR;
  searchType: SearchType;
  placeholderText: string;
}

// Stickers Block - stores actual sticker data (matching Flutter)
export interface StickersBlock extends BaseBlock {
  blockType: BlockTypes.STICKERS;
  title: string;
  columnsCount: number;
  stickers: any[]; // Actual sticker data populated from stickersList
}

// Organizations Block - stores actual organization data (matching Flutter)
export interface OrganizationsBlock extends BaseBlock {
  blockType: BlockTypes.ORGANIZATIONS;
  title: string;
  organizations: any[]; // Actual organization data populated from organizationsList
}

// Rich Text Block
export interface RichTextBlock extends BaseBlock {
  blockType: BlockTypes.RICH_TEXT;
  heading: string;
  text: string;
}

// Announcement Block
export interface AnnouncementBlock extends BaseBlock {
  blockType: BlockTypes.ANNOUNCEMENT;
  text: string;
  textColor: string;
  textBackgroundColor: string;
}

// Question Block
export interface QuestionBlock extends BaseBlock {
  blockType: BlockTypes.QUESTION;
  text: string;
  questionId: string;
  organization: any | null; // Populated organization data (matching Flutter)
}

// Collections Block
export interface CollectionGroup {
  title: string;
  coverImageUrl: string;
  organizations: any[]; // Actual organization data (matching Flutter)
}

export interface CollectionsBlock extends BaseBlock {
  blockType: BlockTypes.COLLECTIONS;
  title: string;
  groups: CollectionGroup[];
}

// List Block - stores actual organization data (matching Flutter)
export interface ListBlock extends BaseBlock {
  blockType: BlockTypes.LIST;
  title: string;
  organizations: any[]; // Actual organization data populated from organizationsList
}

// Union type for all blocks
export type Block =
  | BannerBlock
  | SearchBarBlock
  | StickersBlock
  | OrganizationsBlock
  | RichTextBlock
  | AnnouncementBlock
  | QuestionBlock
  | CollectionsBlock
  | ListBlock;

// Static Page
export interface StaticPageData {
  id: string;
  slug: string;
  title: string;
  greenGradientEnabled: boolean;
  blocks: Block[];
  organizations?: any[];
  stickers?: any[];
}
